export default __webpack_public_path__ + "static/media/subhero6.f30cacf5.jpeg";